import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "linkedin",
  "use": "linkedin-usage",
  "viewBox": "0 0 32 30.6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 30.6\" id=\"linkedin\"><path fill=\"var(--bolt-theme-icon, currentColor)\" d=\"M7.3 10v20.6H.4V9.9zm.4-6.4A3.6 3.6 0 013.8 7a3.6 3.6 0 110-7.1 3.5 3.5 0 014 3.6zM32 18.8v11.8h-6.9v-11c0-2.8-1-4.7-3.4-4.7a3.8 3.8 0 00-3.6 2.5 5.1 5.1 0 00-.2 1.7v11.5h-6.8V9.9h6.8v3A6.8 6.8 0 0124 9.5c4.5 0 7.9 3 7.9 9.3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol